import RestService from "./rest.service";

class competencyService {
  getListCompetencyMapping(cycle_id) {
    return new Promise((fnResolve, fnReject) => {
      if (cycle_id !== undefined && cycle_id !== null && cycle_id !== "") {
        RestService.gets(`app/admin/kpi/competency/mapping?cycle_id=${cycle_id}`).then(
          (response) => {
            fnResolve(response);
          },
          (response) => {
            fnReject(response);
          }
        );
      } else {
        RestService.gets(`app/admin/kpi/competency/mapping`).then(
          (response) => {
            fnResolve(response);
          },
          (response) => {
            fnReject(response);
          }
        );
      }
    });
  }
  getCompetencyMapping(type, cycle_id, serial) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/kpi/competency/mapping/${type}/${serial}?cycle_id=${cycle_id}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
  getAddCompetencyMapping(type, cycle_id, serial) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/kpi/competency/mapping/${type}/${serial}/add?cycle_id=${cycle_id}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  getCompetencyMappingEmployee(type, cycle_id, serial) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/kpi/competency/mapping/${type}/${serial}/employee?cycle_id=${cycle_id}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  saveCompetencyMapping(type, serial, data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.posts(`app/admin/kpi/competency/mapping/${type}/${serial}/save`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
}

export default new competencyService();
